import { useWatch } from "react-hook-form";
import type { ID } from "common/utils/models";
import { usePrintOnDemandProducts } from "@design-lab/entities/product";
import { useCompositionForm } from "./useCompositionForm";

export function useCompositionsList() {
  const { form } = useCompositionForm();
  const formCompositions = useWatch({
    defaultValue: [],
    control: form.control,
    name: "addedCompositions"
  });

  const allCatalogsIds = Array.from(new Set(formCompositions.map(c => c.catalogId)));
  const products = usePrintOnDemandProducts(allCatalogsIds);
  const compositions = formCompositions
    .map(fc => products.flatMap(p => p.data?.compositions ?? []).find(c => c?.id === fc.id))
    .filter((v): v is NonNullable<typeof v> => Boolean(v));

  // Helper function to get a composition by ID
  const getCompositionById = (compositionId: ID) =>
    compositions?.find(comp => comp.id === compositionId);

  return {
    compositions,
    formCompositions,
    getCompositionById,
    products
  };
}
